var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paragraph-s text-neutral-secondary"},[_vm._v(" "+_vm._s(_vm.hint)+" "),(_vm.isLMS)?_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle.source-material-sidebar",modifiers:{"source-material-sidebar":true}}],attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t("common.clickHere")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }